import React, { Component } from 'react';

export class Layout extends Component {
  static displayName = Layout.name;

  // eslint-disable-next-line class-methods-use-this
  render () {
    return (
        <div>
            {this.props.children}
        </div>
    );
  }
}
